






























import Api from "./Api";
import {Component, Inject} from "vue-property-decorator";
import CompanyUserRequired from "../../CompanyRequired";
import rd from "@/modules/vRoutedefs";
import UsersWithoutCardReportRow from "@/components/users/reports/UsersWithoutCardReportRow";

@Component
export default class UsersWithoutCardReport extends CompanyUserRequired {
    @Inject()
    api!: Api;

    loading = false;

    headers = [
        {"text": "Fornavn", value: "firstName", align: "left"},
        {"text": "Etternavn", value: "lastName", align: "left"},
        {"text": "Firma", value: "company", align: "left"},
        {"text": "Mobilnr", value: "phone", align: "left"},
        {"text": "Først innregistrert", value: "lastTimeIn", align: "left"},
        {"text": "Sist innregistrert", value: "lastTimeIn", align: "left"},
        {"text": "Siste anlegg", value: "terminalLocation", align: "left"},
    ];

    items: UsersWithoutCardReportRow[] = [];

    pagination = {
        sortBy: "company"
    };

    async loadResult() {
        this.loading = true;
        try {
            this.items = await this.api.fetchUsersWithoutCardReport(this.company.orgNum);
        } catch (err) {
            this.emitError(err);
        } finally {
            this.loading = false;
        }
    }

    userTo(personGuid: string) {
        return {name: rd.users.name, query: {guid: personGuid}};
    }
    locationTo(locid: number) {
        return {name: rd.locations.location.name, params: {locationId: locid}};
    }

    created() {
        this.loadResult();
    }
}
